// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4a4d8457","160":"a2b3d369","208":"772d2a43","293":"098a3585","453":"0a36081d","516":"497630af","519":"969e45e5","917":"9eda123d","946":"22b15aac"}[chunkId] + ".chunk.js";
};